import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f63fc9da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63fc9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63fc9da')) {
      api.createRecord('f63fc9da', component.options)
    } else {
      api.reload('f63fc9da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f63fc9da&scoped=true", function () {
      api.rerender('f63fc9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pointsStore/inventoryAdjust/index.vue"
export default component.exports